import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { SupportDialogEvents } from '@common/model/admin/supportDialog/events';
import { CoreDialogApiTags, coreDialogApi } from '@cp/entities/dialog';
import { useSupportDialogSocket } from './useSupportDialogSocket';

export const useSupportDialogRealtime = (): void => {
  const dispatch = useDispatch();
  const socket = useSupportDialogSocket();

  useEffect(() => {
    const handleUpdate = () => {
      dispatch(
        coreDialogApi.util.invalidateTags([
          CoreDialogApiTags.UnreadMessagesCount,
          CoreDialogApiTags.DialogList,
        ]),
      );
    };

    socket.on(SupportDialogEvents.Updated, handleUpdate);

    return () => {
      socket.off(SupportDialogEvents.Updated, handleUpdate);
    };
  }, [dispatch, socket]);
};
